/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Observation
 */
export interface Observation {
  /**
   *
   * @type {string}
   * @memberof Observation
   */
  readonly uuid?: string;
  /**
   *
   * @type {number}
   * @memberof Observation
   */
  readonly nrOfMeasurements?: number;
  /**
   *
   * @type {string}
   * @memberof Observation
   */
  readonly gldBroId?: string;
  /**
   *
   * @type {string}
   * @memberof Observation
   */
  observationId: string;
  /**
   *
   * @type {Date}
   * @memberof Observation
   */
  beginPosition: Date;
  /**
   *
   * @type {Date}
   * @memberof Observation
   */
  endPosition: Date;
  /**
   *
   * @type {Date}
   * @memberof Observation
   */
  resultTime: Date;
  /**
   *
   * @type {string}
   * @memberof Observation
   */
  validationStatus: string | null;
  /**
   *
   * @type {string}
   * @memberof Observation
   */
  investigatorKvk: string | null;
  /**
   *
   * @type {string}
   * @memberof Observation
   */
  observationType: string | null;
  /**
   *
   * @type {string}
   * @memberof Observation
   */
  processReference: string | null;
  /**
   *
   * @type {string}
   * @memberof Observation
   */
  airPressureCompensationType: string | null;
  /**
   *
   * @type {string}
   * @memberof Observation
   */
  evaluationProcedure: string | null;
  /**
   *
   * @type {string}
   * @memberof Observation
   */
  measurementInstrumentType: string | null;
  /**
   *
   * @type {Date}
   * @memberof Observation
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof Observation
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof Observation
   */
  gld: string;
  /**
   *
   * @type {string}
   * @memberof Observation
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the Observation interface.
 */
export function instanceOfObservation(value: object): value is Observation {
  if (
    (!("observationId" in (value as Record<string, any>)) &&
      !("observation_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["observationId"] === undefined &&
      (value as Record<string, any>)["observation_id"] === undefined)
  )
    return false;
  if (
    (!("beginPosition" in (value as Record<string, any>)) &&
      !("begin_position" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["beginPosition"] === undefined &&
      (value as Record<string, any>)["begin_position"] === undefined)
  )
    return false;
  if (
    (!("endPosition" in (value as Record<string, any>)) &&
      !("end_position" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["endPosition"] === undefined &&
      (value as Record<string, any>)["end_position"] === undefined)
  )
    return false;
  if (
    (!("resultTime" in (value as Record<string, any>)) &&
      !("result_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["resultTime"] === undefined &&
      (value as Record<string, any>)["result_time"] === undefined)
  )
    return false;
  if (
    (!("validationStatus" in (value as Record<string, any>)) &&
      !("validation_status" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["validationStatus"] === undefined &&
      (value as Record<string, any>)["validation_status"] === undefined)
  )
    return false;
  if (
    (!("investigatorKvk" in (value as Record<string, any>)) &&
      !("investigator_kvk" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["investigatorKvk"] === undefined &&
      (value as Record<string, any>)["investigator_kvk"] === undefined)
  )
    return false;
  if (
    (!("observationType" in (value as Record<string, any>)) &&
      !("observation_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["observationType"] === undefined &&
      (value as Record<string, any>)["observation_type"] === undefined)
  )
    return false;
  if (
    (!("processReference" in (value as Record<string, any>)) &&
      !("process_reference" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["processReference"] === undefined &&
      (value as Record<string, any>)["process_reference"] === undefined)
  )
    return false;
  if (
    (!("airPressureCompensationType" in (value as Record<string, any>)) &&
      !("air_pressure_compensation_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["airPressureCompensationType"] === undefined &&
      (value as Record<string, any>)["air_pressure_compensation_type"] === undefined)
  )
    return false;
  if (
    (!("evaluationProcedure" in (value as Record<string, any>)) &&
      !("evaluation_procedure" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["evaluationProcedure"] === undefined &&
      (value as Record<string, any>)["evaluation_procedure"] === undefined)
  )
    return false;
  if (
    (!("measurementInstrumentType" in (value as Record<string, any>)) &&
      !("measurement_instrument_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["measurementInstrumentType"] === undefined &&
      (value as Record<string, any>)["measurement_instrument_type"] === undefined)
  )
    return false;
  if (!("gld" in value) || value["gld"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function ObservationFromJSON(json: any): Observation {
  return ObservationFromJSONTyped(json, false);
}

export function ObservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Observation {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    nrOfMeasurements: json["nr_of_measurements"] == null ? undefined : json["nr_of_measurements"],
    gldBroId: json["gld_bro_id"] == null ? undefined : json["gld_bro_id"],
    observationId: json["observation_id"],
    beginPosition: new Date(json["begin_position"]),
    endPosition: new Date(json["end_position"]),
    resultTime: new Date(json["result_time"]),
    validationStatus: json["validation_status"],
    investigatorKvk: json["investigator_kvk"],
    observationType: json["observation_type"],
    processReference: json["process_reference"],
    airPressureCompensationType: json["air_pressure_compensation_type"],
    evaluationProcedure: json["evaluation_procedure"],
    measurementInstrumentType: json["measurement_instrument_type"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    gld: json["gld"],
    dataOwner: json["data_owner"],
  };
}

export function ObservationToJSON(json: any): Observation {
  return ObservationToJSONTyped(json, false);
}

export function ObservationToJSONTyped(
  value?: Omit<
    Observation,
    "uuid" | "nr_of_measurements" | "gld_bro_id" | "created" | "updated"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    observation_id: value["observationId"],
    begin_position: value["beginPosition"].toISOString().substring(0, 10),
    end_position: value["endPosition"].toISOString().substring(0, 10),
    result_time: value["resultTime"].toISOString(),
    validation_status: value["validationStatus"],
    investigator_kvk: value["investigatorKvk"],
    observation_type: value["observationType"],
    process_reference: value["processReference"],
    air_pressure_compensation_type: value["airPressureCompensationType"],
    evaluation_procedure: value["evaluationProcedure"],
    measurement_instrument_type: value["measurementInstrumentType"],
    gld: value["gld"],
    data_owner: value["dataOwner"],
  };
}
